import analytics from 'common/analytics';

import './renew-subscription-notification.style.sass';
import template from './renew-subscription-notification.tpl.pug';

class RenewSubscriptionNotificationController {
    renew() {
        analytics.trackRenewNotificationRenew();

        return this.onClose();
    }

    select() {
        this.onClose();
        this.onSelect();
        
        analytics.trackRenewNotificationSelectDefaultCalendar();
    }
}

export default {
    selector: 'dbARenewSubscriptionNotification',
    template: template(),
    controller: RenewSubscriptionNotificationController,
    bindings: {
        plan: '<',
        onSelect: '&',
        onClose: '&'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/notifications/component/renew-subscription-notification/renew-subscription-notification.cmpt.js